import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';

import React, { useEffect } from 'react';

import {
    getReadableReportDescription,
    getReadableReportName,
} from '../../components/Reports/ReportsMapping';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { CustomButton } from '../../../layout/styledcomponents/CustomButton';

import { useLocation, useNavigate } from 'react-router-dom';

import ScheduledComponentPage from '../../components/Dashboard/Dashboard Reports/Scheduled Reservations/ScheduledComponentPage';

import CompletedComponentPage from '../../components/Dashboard/Dashboard Reports/Completed Reservations/CompletedComponentPage';

import UserReservationsComponentPage from '../../components/Dashboard/Dashboard Reports/User Reservations/UserReservationsComponentPage';

import PendingComponentPage from '../../components/Dashboard/Dashboard Reports/Pending Reservations/PendingComponentPage';

import NewReservationsComponentPage from '../../components/Dashboard/Dashboard Reports/New Reservations/NewReservationsComponentPage';

import GuestCountComponentPage from '../../components/Dashboard/Dashboard Reports/Guest Count/GuestCountComponentPage';

import GuestUsersComponentPage from '../../components/Dashboard/Dashboard Reports/Guest Users/GuestUsersComponentPage';

import ExpenseClaimedComponentPage from '../../components/Dashboard/Dashboard Reports/Expense Claimed/ExpenseClaimedComponentPage';

import AddOnsBookedComponentPage from '../../components/Dashboard/Dashboard Reports/Add-ons Booked/AddOnsBookedComponentPage';

import JobsCreatedComponentPage from '../../components/Dashboard/Dashboard Reports/Jobs Created/JobsCreatedComponentPage';

import RsvpsSentComponentPage from '../../components/Dashboard/Dashboard Reports/RSVPs Sent/RsvpsSentComponentPage';

import RsvpsRespondedComponentPage from '../../components/Dashboard/Dashboard Reports/RSVPs Responded/RsvpsRespondedComponentPage';

import ExternalGuestAttendeesComponentPage from '../../components/Dashboard/Dashboard Reports/External Guest Attendees/ExternalGuestAttendeesComponentPage';

import { getDashboardPathSegments } from '../../components/Dashboard/dashboardReportPath';

export default function DashboardReportPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');

    const isIpad = useMediaQuery('(max-width: 1200px)');

    const theme = useTheme();

    const { pathname } = useLocation();

    const { child: reportSegment, mappingKey: reportUrl } =
        getDashboardPathSegments(pathname);

    const navigate = useNavigate();

    const onClickGoBack = () => {
        navigate(`/dashboard`);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const renderReportPage = () => {
        if (reportSegment === 'scheduled') {
            return <ScheduledComponentPage />;
        }

        if (reportSegment === 'completed') {
            return <CompletedComponentPage />;
        }

        if (reportSegment?.includes('pending')) {
            return <PendingComponentPage />;
        }

        if (reportSegment === 'new-bookings') {
            return <NewReservationsComponentPage />;
        }

        if (reportSegment === 'expense-claimed') {
            return <ExpenseClaimedComponentPage />;
        }

        if (reportSegment === 'add-ons-booked') {
            return <AddOnsBookedComponentPage />;
        }

        if (reportSegment === 'jobs-created') {
            return <JobsCreatedComponentPage />;
        }

        if (reportSegment === 'rsvps-sent') {
            return <RsvpsSentComponentPage />;
        }

        if (reportSegment === 'rsvps-responded') {
            return <RsvpsRespondedComponentPage />;
        }

        if (reportSegment === 'guests') {
            return <GuestCountComponentPage />;
        }

        if (reportSegment === 'guest-users') {
            return <GuestUsersComponentPage />;
        }

        if (reportSegment === 'external-guest-attendees') {
            return <ExternalGuestAttendeesComponentPage />;
        }

        return <UserReservationsComponentPage />;
    };

    return (
        <Grid
            sx={{
                width: '100%',

                height: isMobile || isIpad ? '100%' : '80%',

                justifyContent: 'left',

                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',

                    height: 'auto',

                    justifyContent: 'left',

                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',

                        textTransform: 'uppercase',
                    }}
                >
                    {getReadableReportName('type', reportUrl)}
                </Typography>
            </Grid>

            <Grid
                sx={{
                    width: '100%',
                    justifyContent: 'left',
                    paddingTop: '10px',
                    paddingBottom: '20px',
                }}
            >
                <Typography
                    sx={{
                        fontSize: '12px',

                        paddingBottom: isMobile || isIpad ? '30px' : '0px',
                    }}
                >
                    {getReadableReportDescription('type', reportUrl)}
                </Typography>
            </Grid>

            <Grid
                sx={{
                    width: '100%',

                    minHeight: 'auto',

                    justifyContent: 'left',
                }}
            >
                {renderReportPage()}
            </Grid>

            <Grid
                sx={{
                    width: '50%',

                    display: isMobile || isIpad ? 'none' : 'flex',

                    justifyContent: 'flex-start',
                }}
            >
                {' '}
                <CustomButton
                    onClick={onClickGoBack}
                    color='primary'
                    sx={{
                        marginLeft: '-8px',

                        '&:hover': {
                            cursor: 'pointer',

                            color: theme.palette.textAccent.main,

                            backgroundColor: 'transparent',

                            background: 'none',
                        },
                    }}
                >
                    <ArrowBackIcon />

                    <Typography
                        sx={{
                            fontSize: '12px',

                            paddingLeft: '5px',
                        }}
                    >
                        Back to Dashboard
                    </Typography>
                </CustomButton>
            </Grid>
        </Grid>
    );
}
